import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { ConditionalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { getAltTextFromObject } from '@interaktivgmbh/volto-alttextgenerator/helpers';

const SummaryTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  const intl = useIntl();
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  return (
    <>
      <div className="items">
        {items.map((item) => (
          <div className="listing-item" key={item['@id']}>
            <ConditionalLink item={item} condition={!isEditMode}>
              {/* default image is decorative and doesn't require an alt text */}
              {!item.image_field && <img src={DefaultImageSVG} alt="" />}
              {item.image_field && (
                <img
                  src={flattenToAppURL(
                    `${item['@id']}/@@images/${item.image_field}/preview`,
                  )}
                  alt={getAltTextFromObject(item, intl)}
                />
              )}
              <div className="listing-body">
                <h3>{item.title ? item.title : item.id}</h3>
                <p>{item.description}</p>
              </div>
            </ConditionalLink>
          </div>
        ))}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

SummaryTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default SummaryTemplate;
